import { render } from "./BlogPostView.vue?vue&type=template&id=05482315&scoped=true"
import script from "./BlogPostView.vue?vue&type=script&lang=js"
export * from "./BlogPostView.vue?vue&type=script&lang=js"

import "./BlogPostView.vue?vue&type=style&index=0&id=05482315&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05482315"]])

export default __exports__